import { MAIN_CURRENCY } from 'config/constants/links'
import { BNB_ADDRESS } from './constants'

// const MIN_VALUE_DISPLAYED = 0.001

export const getTimeWindowChange = (lineChartData) => {
  if (lineChartData && lineChartData.length > 0) {
    const firstValueObj = lineChartData.find(({ value, open }) => (!!value && value > 0) || (!!open && open > 0))
    const lastValueObj = lineChartData[lineChartData.length - 1]

    const firstValue = firstValueObj?.value || firstValueObj?.open
    const lastValue = lastValueObj?.value || lastValueObj?.open

    let precision = Math.floor(Math.log10(1 / lastValue) + 2) + 1
    if (precision <= 0) precision = 1
    const minValue = Number(1 / 10 ** precision)

    const changeValue = Number((lastValue - firstValue).toFixed(precision))

    return {
      precision,
      valueToDisplay: lastValue > 0 ? lastValue.toFixed(precision) : '',
      changeValue: changeValue > 0 ? Math.max(changeValue, minValue) : Math.min(changeValue, minValue * -1),
      changePercentage: ((changeValue / firstValue) * 100).toFixed(2),
    }
  }

  return {
    precision: 2,
    valueToDisplay: 0,
    changeValue: 0,
    changePercentage: 0,
  }
}

export const getTokenAddress = (tokenAddress: undefined | string) => {
  if (!tokenAddress) {
    return ''
  }
  const lowerCaseAddress = tokenAddress.toLowerCase()
  if (lowerCaseAddress === MAIN_CURRENCY.toLowerCase()) {
    return BNB_ADDRESS
  }

  return lowerCaseAddress
}
